import { bfaEmissaryQuests } from './emissaryQuests';
import { bfaNazjatar } from './nazjatar';

export const bfaTasks = [bfaEmissaryQuests, bfaNazjatar];
